import auth from "@/services/ExerciseInitAuth"

const list = query =>
  auth.get(`${process.env.VUE_APP_EXERCISE_API}admin/chapters/`, {
    params: query
  });

const remove = ID => 
  auth.delete(`${process.env.VUE_APP_EXERCISE_API}admin/chapters/${ID}/`)

const get = ID =>
  auth.get(`${process.env.VUE_APP_EXERCISE_API}admin/chapters/${ID}/`)

const put = (ID, data) => 
  auth.put(`${process.env.VUE_APP_EXERCISE_API}admin/chapters/${ID}/`, data)

const create = data =>
  auth.post(`${process.env.VUE_APP_EXERCISE_API}admin/chapters/`, data);

export default {
  list,
  remove,
  create,
  put,
  get
}
